export const ROUTES_NAMES = {
    profile: 'profile',
    legal: 'legal',
    billingContact: 'billing-contact',
    sdd: 'sdd',
    sso: 'sso',
    wallet: 'wallet',
    proposal: 'proposal',
    project: 'project',
    paymentPreferences: 'payment-preferences',
};
export const LEGAL_ENTITY_ROUTES_NAMES = {
    details: 'details',
    preferences: 'preferences',
    affiliations: 'affiliations',
    bankingDetails: 'banking-details',
};
